export const KitchenPrint = (reciptDetails, item, fullAddress) => {
  const printWindow = window.open("", "_blank");

  const orderKey = `printedOrders_${item.orderid}`;
  let printedItemsForOrder = JSON.parse(localStorage.getItem(orderKey)) || [];

  const unprintedItems = (item?.items || []).filter(
    (subitem) => !printedItemsForOrder.includes(subitem.id),
  );

  if (unprintedItems.length === 0) return;

  const html = `
  <html>
    <head>
      <style>
        @page {
          size: 80mm;
          margin: 0;
        }
        body {
          margin: 0;
          margin-right:15px;
          font-family: Arial, sans-serif;
          font-size: 12px;
          color: black;
        }
       .header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;   
  border-bottom: 1px dashed #000;
}
  .header p {
  margin: 3px 0;   
  padding: 0;
}
        .headerTable {
          width: 100%;
          border-bottom: 1px dashed #000;
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        th, td {
          padding: 5px;
          font-size: 14px;
          text-align: left;
        }
          .header2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  border-bottom: 1px dashed #000; 
  padding-top: 5px;
}
  .row {
  display: flex;
  justify-content: space-between; 
  width: 100%;
}

.header2 p {
  margin: 0;
   padding: 6px 0;
}
      </style>
    </head>

    <body>
      <div class="header">
        <p><strong>${reciptDetails.business_name} - KITCHEN COPY</strong></p>
        <p><strong>Order No:</strong> ${item.daily_order_id}</p>
        <p>Date: ${item.order_date}</p>
        <p>Order Type: ${item.orderType}</p>

        ${
          item.orderType === "dining" ? `<p>Table No: ${item.table_no}</p>` : ""
        }
      </div>

      <div class="headerTable">
        <table>
          <thead>
            <tr>
              <th>Sr.</th>
              <th>ITEM</th>
              <th>QTY</th>
              <th>PRICE</th>
            </tr>
          </thead>

          <tbody>
            ${unprintedItems
              .map((subitem, index) => {
                let customizationText = "";

                try {
                  const customization =
                    subitem.customization && subitem.customization !== "{}"
                      ? JSON.parse(subitem.customization)
                      : null;

                  if (customization) {
                    const parts = Object.values(customization).map((v) =>
                      Array.isArray(v) ? v.join(", ") : v,
                    );
                    customizationText = parts.length
                      ? `(${parts.join(" | ")})`
                      : "";
                  }
                } catch {}

                return `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${subitem.product_id} ${customizationText}</td>
                    <td>${subitem.quantity}</td>
                    <td>${parseFloat(subitem.item_price)}</td>
                  </tr>
                `;
              })
              .join("")}
          </tbody>
        </table>
      </div>

    <div class="header2">
  <div class="row">
    <p>Total Amount :</p>
    <p>Rs. ${Number(item.pay_amount).toFixed(2)}</p>
  </div>
</div>

    </body>
  </html>
  `;

  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();

  const updatedPrintedItems = [
    ...printedItemsForOrder,
    ...unprintedItems.map((i) => i.id),
  ];

  localStorage.setItem(orderKey, JSON.stringify(updatedPrintedItems));
};
